<template>
    <div ref="container" style='width: 100%' class="container d-flex flex-column h-100">
        <header class='text-center'>
            <template v-if='staff'>
                <div class="header-icon header-icon--brand"></div>
                <!-- <img src="img/icon-login.svg" class="header-icon"> -->
                <h1 class="">
                    {{ $t('translations.staff_login_to')}} {{ tBrand('app_name') }} 
                    <!-- <span class="text-orange">ask<span class="text-blue">my</span>GP</span> -->
                </h1>
            </template>
            <template v-else>
                <div class="header-icon header-icon--login"></div>
                <!-- <img src="/img/egl/lock-standard3.svg" alt="" class="header-icon"> -->
                <h1 class="h2">{{ $t('translations.log_in')}}</h1>
            </template>
        </header>

        <div class="container mx-auto">
            <div class="card-default">

                <div>
                    <p v-if='$route.params.message == "resetSuccess"' class="alert alert-success">
                        {{ $t('translations.password_reset_sucess_message')}}
                    </p>
                    <p v-if='$route.params.message == "resetSent"' class="alert alert-success">
                        {{ $t('translations.password_reset_email_sent_message')}}
                    </p>
                </div>
                
                <local-error v-bind:inline='["email", "password"]'></local-error>

                <form role="form">
                    <div class="form-group">
                        <label for="email">{{ $t('translations.email_address')}}</label>
                        <input autocomplete="off" v-on:keypress.enter.prevent="$refs.passwordField.focus();" class="form-control" type="email" name="email" id="email" v-model="auth.email" required aria-labelledby="login email address" aria-describedby="emailLogin">
                        <inline-error type='email' id="emailLogin"></inline-error>
                    </div>
                    

                    <div class="form-group">
                        <label for="password">{{ $t('translations.password')}}</label>
                        <div class="input-group">
                            <input v-on:keypress.enter.prevent="loginUser()" ref='passwordField' class="form-control" id="password" :type="passwordFieldType" v-model='auth.password' required autocomplete="current-password">
                            <div class="input-group-append">
                                <button ref='showhide' @click.prevent="switchVisibility" class="input-group-text">{{show}}</button>
                            </div>
                            <inline-error type='password'></inline-error>
                        </div>
                    </div>

                    <!-- <div class="form-check">
                        <label>
                            <input type="checkbox" class="form-check-input" name="remember" v-model='auth.remember'>
                            Remember Me
                        </label>
                    </div> -->

                    <button v-on:click.prevent='loginUser()' class="btn btn-primary btn-block btn-round mt-2">
                        {{ $t('translations.login')}}
                    </button>

                    <router-link :to="'/password-reset/'" tag="a" style="display:block" class="btn btn-outline-primary btn-round mt-3">{{ $t('translations.link_forgotten_password')}}</router-link>


                </form>
            </div>

        </div><!-- /.container -->
        
        <div v-if='tBrandSetting("conf_show_licence_agreement")' class="mt-auto w-100 p-2">
            <p class="text-center"><strong><a target="_blank" href="https://askmygp.uk/about-us/askmygp-end-user-licence-agreement-eula/">{{ $t('translations.terms_of_use') }}</a></strong></p>
            <!-- <p class="text-center"><strong><a target="_blank" href="https://askmygp.uk/about-us/askmygp-end-user-licence-agreement-eula/">{{ $t('translations.end_user_licence_agreement')}}</a></strong></p>
            <p class="text-center"><strong><a href="https://askmygp.uk/about-us/askmygp-application-privacy-policy/" target="_blank">{{ $t('translations.privacy_policy')}}</a></strong></p> -->
        </div>
        <div v-else class="pb-5"></div>
        
    </div><!--ref:container-->


</template>

<script>

export default {
    props: {
        'postLoginRoute': {default: "profile"},
        'staff': {default: false},
    },
    data: function(){
        return {
            passwordFieldType: 'password',
            show: this.$t('translations.show'),

            auth: {
                email: "",
                password: "",
                remember: 0,
            },
            errors: [],
        }
    },
    mounted() {
        if(this.$root.isLoggedIn()) {
            if(!this.$route.params.next) {
                this.$route.params.next = this.postLoginRoute;
            }
            return this.$root.loadCore(true, this.getNextPath(this.$route.params.next));
        }      
    },
    methods: {
        getNextPath(path) {
            if(!path) {
                return null;
            }
            // Named paths all start with a capital letter
            if(/[A-Z]/.test(path[0])) {
                return {name: path};
            }
            // Paths captured at init (such as /thread-show/1234) all start with a slash.
            if(decodeURIComponent(path)[0] === '/') {
                return {path: path};
            }
            // Paths without a leading slash need it inserting otherwise we loop and get a "navigation duplicated" error
            // These non-named paths aren't really used in the login post-login path, but during testing they caused
            // issues so we need to deal with them
            return {path: "/" + path};
            
        },
        loginUser() {
            this.setLoading(true);
            //axios.post('/api/vp1/patients/authenticate', this.auth).then((res) => {
            return axios.post('/ajaxlogin', this.auth).then((res) => {

                //this.addNotification({type: "success", content: 'Logged in successfully'});

                window.api_token = res.data.api_token;
                this.$root.api_token = window.api_token;

                axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.api_token;

                if(!this.$route.params.next) {
                    this.$route.params.next = this.postLoginRoute;
                }

                

                // This is a bit of a mess because we used to use the "Profile" named path in emails,
                // so we can't guarantee that changing all the named paths to normal paths ("profile")
                // will catch all references (especially where users have old emails, or old bookmarks
                // to /login/Profile).
                this.setLoading(false);
                return this.$root.loadCore(true, this.getNextPath(this.$route.params.next));
            }).catch((error) => {
                this.setLoading(false);
                this.handleError(error, "create");

                // console.log('test error on login user function');
            });
        },

        switchVisibility() {
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
            this.show = this.show === this.$t('translations.show') ? this.$t('translations.hide') : this.$t('translations.show');
           // this.$refs.passwordField.focus();
        }
    }
}
</script>
